import PropTypes from 'prop-types';
import React from 'react';
import translate from '../../translate';
import { connect as connectR } from 'react-redux';
import {
    CancelInstallationVerification,
    INSTALLATION_VERIFICATION_WRONG_OPERATIONAL_STATE,
    INSTALLATION_VERIFICATION_CYCLE_ALREADY_STARTED,
    INSTALLATION_VERIFICATION_NOT_FINISHED,
    INSTALLATION_VERIFICATION_NOT_FOUND,
    LoadAppliancesByLocation,
    resetApplianceRequestStates,
    StartInstallationVerification,
} from '../../../store/applianceSlice';
import { Button } from 'react-bootstrap';
import {
    REQUEST_FAILURE,
    REQUEST_PENDING,
} from '../../../store/network/managedRequest';
import RefreshButton from '../../main/refresh-button';
import { PbRequest } from '../../../store/pbRequest';

class InstallationVerificationForm extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        locationId: PropTypes.number.isRequired,
        applianceId: PropTypes.number.isRequired,
        appliancesByLaundryRoom: PropTypes.shape({}).isRequired,
        LoadAppliancesByLocation: PropTypes.func.isRequired,
        StartInstallationVerification: PropTypes.func.isRequired,
        CancelInstallationVerification: PropTypes.func.isRequired,
        resetApplianceRequestStates: PropTypes.func.isRequired,
        fetchRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        startVerificationRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        cancelVerificationRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
    };

    getAppliance = () => {
        const locationId = this.props.locationId;
        const applianceId = this.props.applianceId;
        if (locationId && applianceId) {
            const byApplianceId =
                this.props.appliancesByLaundryRoom[locationId] || {};
            return byApplianceId[applianceId];
        }
        return null;
    };

    maybeRenderError = () => {
        let hasError = false;
        let tags = [];
        if (this.props.cancelVerificationRequest.status === REQUEST_FAILURE) {
            hasError = true;
            tags = tags.concat(this.props.cancelVerificationRequest.errors);
        }
        if (this.props.startVerificationRequest.status === REQUEST_FAILURE) {
            hasError = true;
            tags = tags.concat(this.props.startVerificationRequest.errors);
        }
        if (this.props.fetchRequest.status === REQUEST_FAILURE) {
            hasError = true;
            tags = tags.concat(this.props.fetchRequest.errors);
        }

        if (hasError) {
            return this.renderErrorForTags(tags);
        } else {
            return null;
        }
    };

    renderErrorForTags = (tags) => {
        let errorText;
        if (tags.includes(INSTALLATION_VERIFICATION_NOT_FOUND)) {
            errorText = this.props.strings.verificationAlreadyFinished;
        } else if (tags.includes(INSTALLATION_VERIFICATION_NOT_FINISHED)) {
            errorText = this.props.strings.verificationNotFinished;
        } else if (
            tags.includes(INSTALLATION_VERIFICATION_CYCLE_ALREADY_STARTED)
        ) {
            errorText = this.props.strings.cycleAlreadyStarted;
        } else if (
            tags.includes(INSTALLATION_VERIFICATION_WRONG_OPERATIONAL_STATE)
        ) {
            errorText =
                this.props.strings.verificationNotAllowedDuringMaintenance;
        } else {
            errorText = this.props.strings.generalError;
        }
        return <div className="alert alert-danger">{errorText}</div>;
    };

    reload = () => {
        const locationId = this.props.locationId;
        if (locationId) {
            this.props.resetApplianceRequestStates();
            this.props.LoadAppliancesByLocation(locationId);
        }
    };

    startVerificationAndReload = () => {
        const applianceId = this.props.applianceId;
        if (applianceId) {
            this.props.StartInstallationVerification(applianceId, this.reload);
        }
    };

    cancelVerificationAndReload = () => {
        const applianceId = this.props.applianceId;
        if (applianceId) {
            this.props.CancelInstallationVerification(applianceId, this.reload);
        }
    };

    renderInstallationVerificationButton = () => {
        const appliance = this.getAppliance();
        if (!appliance) {
            return null;
        }

        const inProgress =
            this.props.cancelVerificationRequest.status === REQUEST_PENDING ||
            this.props.startVerificationRequest.status === REQUEST_PENDING ||
            this.props.fetchRequest.status === REQUEST_PENDING;

        if (appliance.unfinished_installation_verification) {
            return (
                <Button
                    onClick={this.cancelVerificationAndReload}
                    disabled={inProgress}
                    className={'btn btn-primary pull-right mt-10'}
                >
                    {inProgress ? '...' : this.props.strings.cancelVerification}
                </Button>
            );
        } else {
            return (
                <Button
                    onClick={this.startVerificationAndReload}
                    disabled={inProgress}
                    className={'btn btn-primary pull-right mt-10'}
                >
                    {inProgress ? '...' : this.props.strings.startVerification}
                </Button>
            );
        }
    };

    renderRefreshButton = () => {
        const inProgress = this.props.fetchRequest.status === REQUEST_PENDING;

        return <RefreshButton onClick={this.reload} loading={inProgress} />;
    };

    render() {
        function formatTimestampOrElse(epochMillis, fallback) {
            return epochMillis
                ? new Date(epochMillis).toLocaleString('de-DE')
                : fallback;
        }

        function renderValue(value) {
            return (
                <div className="form-line">
                    <input
                        type="text"
                        className="form-control"
                        id=""
                        value={value}
                        disabled
                    />
                </div>
            );
        }

        const appliance = this.getAppliance();
        if (!appliance) {
            return <div />;
        }

        return (
            <div className="form-group">
                <label htmlFor="">{this.props.strings.statusLabel}</label>
                {renderValue(
                    this.props.strings.status[
                        appliance.installation_verification_status
                    ] || '-'
                )}

                <label htmlFor="">{this.props.strings.requestTime}</label>
                {renderValue(
                    formatTimestampOrElse(
                        appliance.installation_verification_request_time,
                        '-'
                    )
                )}

                {this.renderRefreshButton()}
                {this.renderInstallationVerificationButton()}
                {this.maybeRenderError()}
            </div>
        );
    }
}

export default connectR(
    (store) => ({
        appliancesByLaundryRoom: store.appliance.appliancesByLaundryRoom,
        fetchRequest: store.pbRequest[PbRequest.FETCH_APPLIANCES],
        startVerificationRequest:
            store.pbRequest[PbRequest.START_INSTALLATION_VERIFICATION],
        cancelVerificationRequest:
            store.pbRequest[PbRequest.CANCEL_INSTALLATION_VERIFICATION],
    }),
    {
        LoadAppliancesByLocation,
        StartInstallationVerification,
        CancelInstallationVerification,
        resetApplianceRequestStates,
    }
)(translate('InstallationVerificationForm')(InstallationVerificationForm));
